import { render, staticRenderFns } from "./AdvPaymentReceiptManagement.vue?vue&type=template&id=04856446&scoped=true&"
import script from "./AdvPaymentReceiptManagement.vue?vue&type=script&lang=js&"
export * from "./AdvPaymentReceiptManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdvPaymentReceiptManagement.vue?vue&type=style&index=0&id=04856446&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04856446",
  null
  
)

export default component.exports